module.exports = __webpack_public_path__ + "img/DSC_0009.bfcf624b.jpg";